Controller = App.loadClass 'core::Angular/Controller'

class exports.DialogController extends Controller
    constructor: (@scope, @transitions, @modalInstance) ->
        super(@scope, @transitions)

        @scope.save = @save
        @scope.cancel = @cancel
        @scope.closeWithAlert = @closeWithAlert


    closeWithAlert: (json_status, data = null, timeout = 1000) =>
        return unless json_status?

        # check if we should add validation messages to the alert
        if json_status.type is 'error' and data?.messages instanceof Array
            messages = data.messages

        @scope.setAlert json_status, messages, timeout

        if json_status.type isnt 'error'
            setTimeout () =>
                @modalInstance.close(data)
            , timeout

    cancel: () =>
        @modalInstance.dismiss('cancel')

    # Stubs
    save: (data = null) =>
        @modalInstance.close(data)
